import styled, { css } from "styled-components";
import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  width: 100%;

  && .MuiFormLabel-root {
    font-size: 12px;
  }
`;

export const IconControlsContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;

  display: none;

  transform: translate(-50%, -50%);

  z-index: 1;
`;

export const CsvPreview = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0;
`;

export const CsvContainer = styled.div`
  position: relative;
  width: 100%;
  height: 120px;
  background-color: transparent;
  border-radius: 4px;
  border: 1px dashed ${COLORS.BLACK_25};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  .filepicker {
    height: 120px;
    border: none;
    background-color: transparent;
  }

  .dropzone .dz-message {
    margin: 42px 0;
  }

  .dropzone.dz-drag-hover {
    border: solid 2px #d8ddec;
  }

  .dropzone .dz-preview.dz-image-preview {
    display: none;
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-mark {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-message {
    display: none;
  }

  .dropzone .dz-preview .dz-image {
    display: none;
  }

  .dz-details {
    display: none;
  }

  ${({ file }: any) =>
    file
      ? css`
          .dropzone .dz-message {
            display: none;
          }
        `
      : css`
          .dropzone.dz-started .dz-message {
            display: block;
          }
        `};

  &:hover {
    .dropzone .dz-message {
      display: none;
    }

    ${({ hasError }: any) =>
      hasError
        ? css`
            border: solid 1px ${COLORS.RED};
          `
        : css`
            border: 1px dashed ${COLORS.BLACK_25};
          `}

    ${IconControlsContainer} {
      display: flex;
      flex-direction: row;
    }

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 0.7);
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;

  width: 100%;
  height: 120px;

  ${({ title }: any) =>
    title &&
    css`
      margin-top: 4px;
    `}

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;

  border-radius: 4px;
  border: 1px dashed ${COLORS.BLACK_25};

  .filepicker {
    height: 120px;

    border: none;
    background-color: transparent;
  }

  .dropzone .dz-message {
    margin: 42px 0;
  }

  .dropzone.dz-drag-hover {
    border: solid 2px #d8ddec;
  }

  .dropzone .dz-preview.dz-image-preview {
    display: none;
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-mark {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-message {
    display: none;
  }

  .dropzone .dz-preview .dz-image {
    display: none;
  }

  .dz-details {
    display: none;
  }

  ${({ hasError }: any) =>
    hasError &&
    css`
      border: solid 1px ${COLORS.RED}

      &:active {
        border: solid 1px ${COLORS.RED}
      }

      &:focus {
        border: solid 1px ${COLORS.RED}
      }
    `};

  ${({ image }: any) =>
    image
      ? css`
          background-image: url(${image});
          background-color: transparent;

          .dz-message {
            display: none;
          }
        `
      : css`
          .dropzone.dz-started .dz-message {
            display: block;
          }
        `};

  &:hover {
    .dropzone .dz-message {
      display: none;
    }

    ${({ image, hasError }: any) =>
      !hasError && image
        ? css`
            border: none;
          `
        : css`
            border: 1px dashed ${COLORS.BLACK_25};
          `}

    ${IconControlsContainer} {
      display: flex;
      flex-direction: row;
    }

    &:after {
      content: "";

      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      border-radius: 4px;

      background-color: rgba(255, 255, 255, 0.7);
    }
  }
`;

export const PDFContainer = styled.div`
  position: relative;

  width: 100%;
  height: 240px;

  ${({ title }: any) =>
    title &&
    css`
      margin-top: 4px;
    `}

  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;

  border-radius: 4px;
  border: 1px dashed ${COLORS.BLACK_25};

  .filepicker {
    height: 240px;

    border: none;
  }

  .dropzone .dz-message {
    margin: 100px 0;
  }

  .dropzone.dz-drag-hover {
    border: solid 2px #d8ddec;
  }

  .dropzone .dz-preview.dz-image-preview {
    display: none;
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-mark {
    display: none;
  }

  .dropzone .dz-preview.dz-error .dz-error-message {
    display: none;
  }

  .dropzone .dz-preview .dz-image {
    width: 170px;
  }

  ${({ hasError }: any) =>
    hasError &&
    css`
      border: solid 1px ${COLORS.RED}

      &:active {
        border: solid 1px ${COLORS.RED}
      }

      &:focus {
        border: solid 1px ${COLORS.RED}
      }
    `};

  ${({ image }: any) =>
    image
      ? css`
          background-color: ${COLORS.BLACK_4};

          .dz-message {
            display: none;
          }

          .dropzone .dz-preview {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0;
          }
        `
      : css`
          .dropzone .dz-message {
            display: block;
          }
          .dropzone .dz-preview {
            display: none;
          }
        `};

  &:hover {
    .dropzone .dz-message {
      display: none;
    }

    ${({ image, hasError }: any) =>
      !hasError && image
        ? css`
            border: none;
          `
        : css`
            border: 1px dashed ${COLORS.BLACK_25};
          `}

    ${IconControlsContainer} {
      display: flex;
      flex-direction: row;
      z-index: 2;
    }

    &:after {
      content: "";

      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      border-radius: 4px;

      background-color: rgba(255, 255, 255, 0.7);
    }
  }
`;
